import { useState } from 'react';
import { MenuItem, Popover, Select } from '@mui/material';
import styles from './ccf-reschedule-popover.module.scss';
import DatePicker from 'react-datepicker';
import {
  CcfBox,
  CcfButton,
  CcfCalendarIcon,
  CcfCloseIcon,
  CcfTextField,
  CcfTypography,
  CcfUpArrowIcon,
} from '@nice-ccf/ui-controls';
import { useSelector } from 'react-redux';
import { activeContactSelector } from '../../ccf-inbox.slice';

/* eslint-disable-next-line */
export interface CcfReschedulePopoverProps {
  anchorEl?: any;
  reschedulePopovercloseHandler?: any;
  triggerHungUp: any;
}

/**
 *
 * @param props -
 * @example
 * @returns
 */
export function CcfReschedulePopover(props: CcfReschedulePopoverProps) {
  const selectedContact = useSelector(activeContactSelector);
  const [startDate, setStartDate] = useState(new Date());
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [rescheduleTimezone, setRescheduleTimezone] = useState(
    '(GMT-07:00) Mountain Time'
  );
  const [rescheduleNotes, setRescheduleNotes] = useState('');

  /**
   * Used to Reschedule the contact
   * @param event -React.SyntheticEvent
   * @param reason -string
   * @example - rescheduleContact()
   */
  const rescheduleContact = () => {
    props.reschedulePopovercloseHandler();
    props.triggerHungUp();
  };
  return (
    <Popover
      id={'reschedule-popover'}
      open={Boolean(props?.anchorEl)}
      keepMounted
      anchorEl={props?.anchorEl}
      onClose={props?.reschedulePopovercloseHandler}
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'center',
        horizontal: 'left',
      }}
      style={{
        marginLeft: '90px',
        marginTop: '160px',
      }}
    >
      <CcfBox className={styles.reschedulePopupContainer}>
        <CcfBox className={styles.headerSection}>
          <CcfTypography className={styles.headerTitle}>
            Reschedule
          </CcfTypography>
          <CcfCloseIcon
            className={styles.closeIcon}
            onClick={props?.reschedulePopovercloseHandler}
          />
        </CcfBox>
        <CcfBox mt={2}>
          <CcfButton
            primary
            fullWidth
            className={`${styles.btn} ${styles.snoozeButton}`}
          >
            <CcfTypography className={`${styles.btnText} ${styles.txtSnooze}`}>
              Snooze
            </CcfTypography>
          </CcfButton>
        </CcfBox>
        <CcfBox mt={2}>
          <CcfTextField
            fullWidth
            id="customerName"
            variant="outlined"
            size="small"
            value={`${[
              selectedContact?.customer?.firstName,
              selectedContact?.customer?.middleName,
              selectedContact?.customer?.lastName,
            ]
              .filter(Boolean)
              .join(' ')}`}
            focused={false}
            InputProps={{
              className: styles.firstNameTxtBox,
            }}
          />
        </CcfBox>
        <CcfBox mt={2}>
          <CcfTextField
            fullWidth
            id="phoneNumber"
            variant="outlined"
            size="small"
            value={selectedContact?.customer.phoneNo}
            focused={false}
            InputProps={{
              className: styles.inputTxt,
            }}
          />
        </CcfBox>
        <CcfBox mt={2}>
          <DatePicker
            selected={startDate}
            onChange={(date: any) => setStartDate(date)}
            timeInputLabel="Time :"
            dateFormat="eee, MMM d, yyyy h:mm aa"
            showTimeInput
            className={styles.datePickerBox}
            popperPlacement="bottom"
            popperModifiers={[
              {
                name: 'offset',
                options: {
                  offset: [5, 10],
                },
              },
              {
                name: 'preventOverflow',
                options: {
                  rootBoundary: 'viewport',
                  tether: false,
                  altAxis: true,
                },
              },
            ]}
            onKeyDown={(e) => {
              e.preventDefault();
            }}
            onClickOutside={() => {
              setShowDatePicker(false);
            }}
            onInputClick={() => {
              setShowDatePicker(true);
            }}
            onSelect={() => {
              setShowDatePicker(false);
            }}
            open={showDatePicker}
          />
          <CcfCalendarIcon
            className={styles.calenderIcon}
            onClick={() => {
              setShowDatePicker(true);
            }}
          />
        </CcfBox>
        <CcfBox mt={-1}>
          <Select
            fullWidth
            displayEmpty
            name="timezone"
            variant="outlined"
            className={styles.dropdown}
            SelectDisplayProps={{
              className: styles.inputTxt,
            }}
            value={rescheduleTimezone}
            sx={{
              '&& fieldset': {
                border: '1px solid #c4c4c4',
              },
            }}
            IconComponent={() => (
              <CcfUpArrowIcon className={styles.arrowIconForDropdown} />
            )}
            onChange={(e: any) => {
              setRescheduleTimezone((e?.target as HTMLSelectElement).value);
            }}
          >
            <MenuItem value={'(GMT-07:00) Mountain Time'}>
              (GMT-07:00) Mountain Time
            </MenuItem>
            <MenuItem value={'(GMT-05:00) Eastern Time'}>
              (GMT-05:00) Eastern Time
            </MenuItem>
          </Select>
        </CcfBox>
        <CcfBox mt={2}>
          <CcfTextField
            id="Notes"
            fullWidth
            variant="outlined"
            multiline
            rows={3}
            maxRows={3}
            autoFocus={false}
            placeholder="Notes"
            InputProps={{ className: styles.inputTxt }}
            focused={false}
            value={rescheduleNotes}
            onChange={(e: any) => setRescheduleNotes(e.target.value)}
          />
        </CcfBox>
        <CcfBox className={styles.btnContainer}>
          <CcfButton
            className={`${styles.btn} ${styles.CancelButton}`}
            onClick={props.reschedulePopovercloseHandler}
          >
            <CcfTypography className={`${styles.btnText} ${styles.txtCancel}`}>
              Cancel
            </CcfTypography>
          </CcfButton>
          <CcfButton
            primary
            className={`${styles.btn} ${styles.saveButton}`}
            onClick={rescheduleContact}
          >
            <CcfTypography className={`${styles.btnText} ${styles.txtSave}`}>
              Save
            </CcfTypography>
          </CcfButton>
        </CcfBox>
      </CcfBox>
    </Popover>
  );
}

export default CcfReschedulePopover;
